import { GlBadge, GlButton, GlIcon } from '../../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { createAlert } from '../../../../alert.js?vue3';
import { reportToSentry } from '~/ci/utils';
import CrudComponent from '../../../../vue_shared/components/crud_component.vue?vue3';
import { __ } from '~/locale';
import { getQueryHeaders } from '../../../pipeline_details/graph/utils.js?vue3';
import { graphqlEtagPipelinePath } from '~/ci/pipeline_details/utils';
import { setupQueryPollingByVisibility } from '~/graphql_shared/utils';
import getPipelineFailedJobsCount from '../../graphql/queries/get_pipeline_failed_jobs_count.query.graphql';
import FailedJobsList from './failed_jobs_list.vue?vue3';
import { POLL_INTERVAL } from './constants';
export default {
    name: 'PipelineFailedJobsWidget',
    fetchError: __('An error occurred fetching failed jobs count'),
    components: {
        GlBadge,
        GlButton,
        GlIcon,
        FailedJobsList,
        CrudComponent
    },
    inject: [
        'graphqlPath'
    ],
    props: {
        pipelineIid: {
            required: true,
            type: String
        },
        pipelinePath: {
            required: true,
            type: String
        },
        projectPath: {
            required: true,
            type: String
        }
    },
    emits: [
        'retried'
    ],
    apollo: {
        failedJobsCount: {
            context () {
                return {
                    ...getQueryHeaders(this.graphqlResourceEtag),
                    featureCategory: 'continuous_integration'
                };
            },
            query: getPipelineFailedJobsCount,
            variables () {
                return {
                    fullPath: this.projectPath,
                    pipelineIid: this.pipelineIid
                };
            },
            update ({ project }) {
                this.isPipelineActive = project?.pipeline?.active || false;
                return project?.pipeline?.jobs?.count || 0;
            },
            error (err) {
                createAlert({
                    message: this.$options.fetchError
                });
                reportToSentry(this.$options.name, err);
            }
        }
    },
    data () {
        return {
            failedJobsCount: 0,
            isExpanded: false,
            // explicitly set to null so watcher can detect
            // reactivity changes for polling
            isPipelineActive: null
        };
    },
    computed: {
        graphqlResourceEtag () {
            return graphqlEtagPipelinePath(this.graphqlPath, this.pipelineIid);
        },
        failedJobsCountBadge () {
            return `${this.isMaximumJobLimitReached ? '100+' : this.failedJobsCount}`;
        },
        iconName () {
            return this.isExpanded ? 'chevron-down' : 'chevron-right';
        },
        isMaximumJobLimitReached () {
            return this.failedJobsCount > 100;
        }
    },
    watch: {
        isPipelineActive (active) {
            if (!active) {
                this.$apollo.queries.failedJobsCount.stopPolling();
            } else {
                this.$apollo.queries.failedJobsCount.startPolling(POLL_INTERVAL);
                // ensure we only toggle polling back on tab switch
                // if the pipeline is active
                this.pollingVisibilityCleanup?.();
                this.pollingVisibilityCleanup = setupQueryPollingByVisibility(this.$apollo.queries.failedJobsCount, POLL_INTERVAL);
            }
        }
    },
    beforeDestroy () {
        this.pollingVisibilityCleanup?.();
        this.$apollo.queries.failedJobsCount.stopPolling();
    },
    methods: {
        toggleWidget () {
            this.isExpanded = !this.isExpanded;
        },
        async refetchCount () {
            // Emitted before the local refetch so the parent refreshes the pipeline (collapsing
            // the widget) even if that refetch throws.
            this.$emit('retried');
            try {
                // "pause" polling during manual refetch of count
                // to avoid redundant calls
                this.$apollo.queries.failedJobsCount.stopPolling();
                await this.$apollo.queries.failedJobsCount.refetch();
            } catch (err) {
                createAlert({
                    message: this.$options.fetchError
                });
                reportToSentry(this.$options.name, err);
            } finally{
                if (this.isPipelineActive) {
                    this.$apollo.queries.failedJobsCount.startPolling(POLL_INTERVAL);
                }
            }
        }
    },
    ariaControlsId: 'pipeline-failed-jobs-widget'
};
